import { useState } from "react";
import { api, apiError } from "@/api";

const INQUIRY_TYPES = [
  "Venue or programming",
  "Brand partnership or sponsorship",
  "Press",
  "Creative collaboration",
  "General inquiry",
];

export default function ContactForm() {
  const [form, setForm] = useState({
    name: "", email: "", inquiry_type: "", organization: "", message: "", link: "", website: "",
  });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/contact", form);
      setSuccess(true);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  if (success) {
    return (
      <div className="ank-success" data-testid="contact-success">
        <p className="ank-success-title">MESSAGE RECEIVED.</p>
        <p className="ank-modal-copy">Thanks for reaching out — we'll get back to you soon.</p>
      </div>
    );
  }

  return (
    <form className="ank-form" onSubmit={submit} data-testid="contact-form">
      <input type="text" value={form.website} onChange={(e) => setForm({ ...form, website: e.target.value })}
        className="ank-honeypot" tabIndex={-1} autoComplete="off" aria-hidden="true" />
      <div className="ank-field-row">
        <div className="ank-field">
          <label htmlFor="ct-name">NAME *</label>
          <input id="ct-name" data-testid="contact-name" required value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })} />
        </div>
        <div className="ank-field">
          <label htmlFor="ct-email">EMAIL *</label>
          <input id="ct-email" data-testid="contact-email" type="email" required value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })} />
        </div>
      </div>
      <div className="ank-field">
        <label htmlFor="ct-type">INQUIRY TYPE *</label>
        <select id="ct-type" data-testid="contact-type" required value={form.inquiry_type}
          onChange={(e) => setForm({ ...form, inquiry_type: e.target.value })}>
          <option value="">Select…</option>
          {INQUIRY_TYPES.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
      </div>
      <div className="ank-field">
        <label htmlFor="ct-org">ORGANIZATION (OPTIONAL)</label>
        <input id="ct-org" data-testid="contact-org" value={form.organization}
          onChange={(e) => setForm({ ...form, organization: e.target.value })} />
      </div>
      <div className="ank-field">
        <label htmlFor="ct-msg">MESSAGE *</label>
        <textarea id="ct-msg" data-testid="contact-message" rows={4} required value={form.message}
          onChange={(e) => setForm({ ...form, message: e.target.value })} />
      </div>
      <div className="ank-field">
        <label htmlFor="ct-link">RELEVANT LINK (OPTIONAL)</label>
        <input id="ct-link" data-testid="contact-link" type="url" placeholder="https://…" value={form.link}
          onChange={(e) => setForm({ ...form, link: e.target.value })} />
      </div>
      {error && <p className="ank-form-error" data-testid="contact-error">{error}</p>}
      <button type="submit" className="ank-submit" disabled={busy} data-testid="contact-submit-btn">
        {busy ? "SENDING…" : "SEND MESSAGE"}
      </button>
    </form>
  );
}
